import { render, staticRenderFns } from "./designInfo.vue?vue&type=template&id=b0dee010&scoped=true"
import script from "./designInfo.vue?vue&type=script&lang=js"
export * from "./designInfo.vue?vue&type=script&lang=js"
import style0 from "./designInfo.vue?vue&type=style&index=0&id=b0dee010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dee010",
  null
  
)

export default component.exports